import { render } from "./dashboardCentro.vue?vue&type=template&id=202423e5&ts=true"
import script from "./dashboardCentro.vue?vue&type=script&lang=ts"
export * from "./dashboardCentro.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\CarpeDiem\\AntiSmoking\\Backend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__